import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@fast-ai/ui-components';

import { UlContext } from '../List/context';

const ListItem = forwardRef(({ sx, highlighted, ...rest }, ref) => {
	const { inline } = useContext(UlContext);
	return (
		<Box
			ref={ref}
			as="li"
			sx={{
				mx: 0,
				px: 0,
				...(inline ? { mr: [1, 2], display: 'inline-block' } : {}),
				backgroundColor: highlighted ? 'muted' : 'transparent',
				...sx,
			}}
			{...rest}
		/>
	);
});

ListItem.propTypes = {
	/** Children to be rendered in the main container. */
	children: PropTypes.node,
	highlighted: PropTypes.bool,
};

ListItem.displayName = 'ListItem';

export default ListItem;
